import {
  ATTENTION_TAB_TITLE_I18N_KEY,
  SUGGESTION_TAB_TITLE_I18N_KEY,
} from '../../utils/constants/suggestionTabAlerts';

export const getTabAlertTitleKey = (hasAttentionItems: boolean) =>
  hasAttentionItems
    ? ATTENTION_TAB_TITLE_I18N_KEY
    : SUGGESTION_TAB_TITLE_I18N_KEY;
